import { render } from "./OpenAI.vue?vue&type=template&id=76a2304a&scoped=true"
import script from "./OpenAI.vue?vue&type=script&lang=js"
export * from "./OpenAI.vue?vue&type=script&lang=js"

import "./OpenAI.vue?vue&type=style&index=0&id=76a2304a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a2304a"]])

export default __exports__